<template>
    <div v-if="!resetSuccess" class="reset-pwd-page">
        <van-form @submit="handleSubmit" class="reset-form">
            <van-field v-model="form.mobile" type="tel" center clearable label="手机号:" placeholder="请输入11位手机号码"
                :rules="[{ required: true }, { pattern: /^1\d{10}$/, message: '请输入正确的手机号' }]" />

            <van-field v-model="form.code" type="number" center clearable label="验证码:" placeholder="请输入验证码"
                :rules="[{ required: true }]">
                <template #button>
                    <van-button size="small" type="info" native-type="button" plain hairline @click="getCode"
                        :disabled="countdown > 0">
                        {{ countdown > 0 ? `${countdown}秒后重发` : '获取验证码' }}
                    </van-button>
                </template>
            </van-field>

            <van-field v-model="form.password" :type="showPassword ? 'text' : 'password'" center clearable label="密码:"
                placeholder="请输入新密码"
                :rules="[{ required: true }, { pattern: /^[\S]{4,16}$/, message: '密码长度为4-16位' }]" />

            <van-field v-model="form.confirmPassword" :type="showConfirmPassword ? 'text' : 'password'" center clearable
                label="确认密码:" placeholder="请再次输入密码"
                :rules="[{ required: true, }, { validator: checkSamePwd, message: '两次输入的密码不一致' }]" />

            <div class="submit-wrapper">
                <van-button type="primary" size="normal" native-type="submit" class="submit-btn"
                    :disabled="!resetBtnEnable">
                    提交
                </van-button>
            </div>
        </van-form>
    </div>
    <div v-else class="reset-success-page">
        <!-- 成功图标和提示文字 -->
        <div class="success-content">
            <div class="success-icon">
                <van-icon name="success" color="#fff" size="24" />
            </div>
            <p class="success-text">重置密码成功</p>
        </div>

        <!-- 登录按钮 -->
        <div class="login-btn-wrapper">
            <van-button type="primary" size="normal" class="login-btn" @click="goToLogin">
                立即登录
            </van-button>
        </div>
    </div>
</template>

<script>
import * as deviceApi from "@/api/device"
export default {
    name: 'ResetPwdPage',
    data() {
        return {
            form: {
                mobile: '',
                code: '',
                password: '',
                confirmPassword: ''
            },
            countdown: 0,
            timer: null,
            showPassword: false,
            showConfirmPassword: false,
            resetSuccess: false
        }
    },
    computed: {
        resetBtnEnable() {
            return !!this.form.mobile && !!this.form.code && !!this.form.password && !!this.form.confirmPassword
        }

    },
    methods: {
        getCode() {
            if (!this.form.mobile || !/^1\d{10}$/.test(this.form.mobile)) {
                this.$toast('请先输入正确的手机号')
                return
            }
            // 发送验证码
            deviceApi.sendSmsCode(this.form.mobile).then(data => {
                this.$toast.success("验证码已发送");
                this.countdown = 60
                this.timer = setInterval(() => {
                    this.countdown--
                    if (this.countdown <= 0) {
                        clearInterval(this.timer)
                        this.timer = null
                    }
                }, 1000);
            }).catch(err => {
                console.error("发送验证码失败", err);
                if (err.message) {
                    this.$toast(err.message);
                }
            });
        },
        togglePassword() {
            this.showPassword = !this.showPassword
        },
        toggleConfirmPassword() {
            this.showConfirmPassword = !this.showConfirmPassword
        },
        checkSamePwd(value) {
            return value === this.form.password
        },
        handleSubmit() {
            const { mobile, code, password, confirmPassword } = this.form
            if (password != confirmPassword) {
                this.$toast("两次输入的密码不一致")
                return
            }
            deviceApi.resetPassword(mobile, code, password).then(data => {
                console.log("密码重置成功")
                this.resetSuccess = true;
            }).catch(err => {
                console.error("密码重置失败", err);
                if (err.message) {
                    this.$toast(err.message);
                }
            })
        },
        goToLogin() {
            // 跳转到登录页
            this.$router.go(-1);
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
        }
    }
}
</script>

<style lang="scss" scoped>
.reset-pwd-page {
    min-height: 100vh;
    background: #f1f4f9;
    padding: 20px;
    box-sizing: border-box;
}

.reset-form {
    background: #fff;
    border-radius: 8px;
    padding: 10px 20px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.code-btn {
    color: #82aaff;
    border-color: #82aaff;
}

.pwd-icon {
    font-size: 18px;
    color: #999;
}

.submit-wrapper {
    margin-top: 30px;
    text-align: center;
}

.submit-btn {
    width: 60%;
    border-radius: 24px;
    border: none;
}

.reset-success-page {
    min-height: 100vh;
    background: #f5f6fa;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 80px;
    box-sizing: border-box;
}

.success-content {
    text-align: center;
    margin-bottom: 60px;

    .success-icon {
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background: linear-gradient(135deg, #95A5F7, #5573f1);
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 0 auto 20px;
    }

    .success-text {
        font-size: 15px;
        color: #333;
        margin: 0;
    }
}

.login-btn-wrapper {
    width: 100%;
    padding: 0 40px;
    display: flex;
    justify-content: center;

    .login-btn {
        width: 60%;
        border-radius: 24px;
        background: #5573f1;
        border: none;
        color: #fff;
    }
}
</style>
